export default __webpack_public_path__ + "static/media/O-045.b5c62d58.png";